import api from './api';
import { PostCategory } from '../types';

export const postCategoryService = {
  list: async (params?: { with_counts?: boolean }) => {
    const response = await api.get<{ categories: PostCategory[] }>('/post-categories', {
      params: params?.with_counts ? { with_counts: true } : undefined,
    });
    return response.data.categories;
  },

  get: async (id: number) => {
    const response = await api.get<{ category: PostCategory }>(`/post-categories/${id}`);
    return response.data.category;
  },

  create: async (payload: Partial<PostCategory>) => {
    const response = await api.post<{ message: string; category: PostCategory }>('/post-categories', payload);
    return response.data;
  },

  update: async (id: number, payload: Partial<PostCategory>) => {
    const response = await api.put<{ message: string; category: PostCategory }>(`/post-categories/${id}`, payload);
    return response.data;
  },

  remove: async (id: number) => {
    const response = await api.delete<{ message: string }>(`/post-categories/${id}`);
    return response.data;
  },
};

